import React, { useState } from "react";
import { Loader2Icon } from "lucide-react";
import { useBookings } from "../../contexts/BookingsContext";
import { clinic } from "../../data/clinic";
import { toDateTime } from "../../utils/slots";
import type { Appointment } from "../../types/booking";
interface CancelAppointmentProps {
  appointment: Appointment;
  onDark?: boolean;
}
export function CancelAppointment({
  appointment,
  onDark = false
}: CancelAppointmentProps) {
  const {
    cancelAppointment
  } = useBookings();
  const [confirming, setConfirming] = useState(false);
  const [busy, setBusy] = useState(false);
  const hoursLeft = (toDateTime(appointment.dateKey, appointment.time).getTime() - Date.now()) / 3_600_000;
  if (hoursLeft < 24) {
    return <p className={`text-xs ${onDark ? "text-white/75" : "text-muted"}`} data-id="element-29" data-mp="11cbbrlmkxx3h">
        Moins de 24 h avant : appelez le{" "}
        <a href={clinic.phoneHref} className="font-medium underline" data-id="element-30" data-mp="2rmmodnoxgelp">
          {clinic.phone}
        </a>{" "}
        pour annuler.
      </p>;
  }
  const ghost = onDark ? "border-white/30 text-white hover:bg-white/10" : "border-line text-ink hover:border-danger hover:text-danger";
  if (!confirming) {
    return <button type="button" onClick={() => setConfirming(true)} className={`whitespace-nowrap rounded-full border px-4 py-2 text-sm font-medium transition-colors duration-150 ${ghost}`} data-id="element-31" data-mp="2d27ydru3m8mx">
        Annuler le rendez-vous
      </button>;
  }
  return <div className="flex flex-wrap items-center gap-2" role="group" aria-label="Confirmer l'annulation" data-id="element-32" data-mp="1fefzmtfe6zd8">
      <button type="button" disabled={busy} onClick={async () => {
      setBusy(true);
      await cancelAppointment(appointment.id);
    }} className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-danger px-4 py-2 text-sm font-medium text-white transition-colors duration-150 hover:bg-danger/90 disabled:opacity-70" data-id="element-33" data-mp="1uc013qd2ycen">
        {busy && <Loader2Icon className="h-4 w-4 animate-spin" aria-hidden="true" data-id="element-34" data-mp="37v8u0z9hofg2" />}
        Confirmer l'annulation
      </button>
      <button type="button" disabled={busy} onClick={() => setConfirming(false)} className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium ${onDark ? "text-white hover:bg-white/10" : "text-muted hover:text-ink"}`} data-id="element-35" data-mp="3csskcxjgoiod">
        Garder
      </button>
    </div>;
}